<template>
  <div class="account-page settingPage" >
    <AccountPanel title="Ustawienia konta">
      <div class="row">
        <div class="col-12">
          <b-form-group label="Pokaż cenę" description="Pozwala wybrać rodzaj ceny wyświetlanej na liście produktów">
            <b-form-radio-group :disabled="true" v-model="settings.B2B_CLIENT_PRICE_TYPE" :options="priceType" name="priceKind">
            </b-form-radio-group>
          </b-form-group>
        </div>
        <div class="col-12">
          <b-form-group label="Rodzaj ceny" description="Pozwala wybrać typ ceny wyświetlanej na liście produktów. Cena oryginalna to cena hurtowa kontrahenta.
              Cena klienta to cena hurtowa z naliczoną marżą klienta">
            <b-form-radio-group :disabled="true" v-model="settings.B2B_CLIENT_PRICE" :options="priceOptions" name="priceType">
            </b-form-radio-group>
          </b-form-group>
        </div>
        <div class="col-12">
          <b-form-group label="Marża" description="Marża doliczona do ceny netto kontrahenta">
            <b-form-radio-group :disabled="true" v-model="settings.B2B_CLIENT_MARGIN_TYPE" :options="marginType" name="marginType">
            </b-form-radio-group>
          </b-form-group>
        </div>
        <div class="col-12 col-md-6">
          <b-input-group readonly :append="settings.B2B_CLIENT_MARGIN_TYPE == 'percent' ? '%' : 'zł'">
            <b-form-input readonly type="number" v-model="settings.B2B_CLIENT_MARGIN" min="0" step="0.01"></b-form-input>
          </b-input-group>
        </div>

      </div>
    </AccountPanel>

  </div>
</template>

<script>

    import { mapState } from 'vuex';
    import AccountPanel from './AccountPanel.vue'
    import {BFormGroup} from 'bootstrap-vue/esm/components/form-group/form-group'
    import {BFormRadioGroup} from 'bootstrap-vue/esm/components/form-radio/form-radio-group'
    import {BInputGroup} from 'bootstrap-vue/esm/components/input-group/input-group'
    import {BFormInput} from 'bootstrap-vue/esm/components/form-input/form-input'

    export default {
        components: {AccountPanel, BFormGroup, BFormRadioGroup, BFormInput, BInputGroup},
        data () {
            return {
                priceOptions: [
                    { text: 'oryginalną', value: 'origin' },
                    { text: 'klienta', value: 'client' },
                ],
                priceType: [
                    { text: 'netto', value: 'net' },
                    { text: 'brutto', value: 'gross' },
                ],
                marginType: [
                    { text: 'procent', value: 'percent' },
                    { text: 'kwota', value: 'amount' },
                ]
            }
        },
        methods: {
            delay(ms) {
                return new Promise(function (resolve) { return setTimeout(resolve, ms); });
            }
        },

        computed: {
            ...mapState({
                settings: state => state.user.userSettings
            }),
        },
        beforeMount() {
            if (!this.$store.state.user.authorizedUser) {
                this.$router.replace({name: 'mainPage'});
            }

            this.$watch('settings.B2B_CLIENT_PRICE_TYPE', function (newValue, oldValue) {
                if (newValue != oldValue) {
                    this.$store.dispatch('user/saveUserSetting', {name: 'B2B_CLIENT_PRICE_TYPE', value: newValue});
                }
            });
            this.$watch('settings.B2B_CLIENT_PRICE', function (newValue, oldValue) {
                if (newValue != oldValue) {
                    this.$store.dispatch('user/saveUserSetting', {name: 'B2B_CLIENT_PRICE', value: newValue});
                }
            });
            this.$watch('settings.B2B_CLIENT_MARGIN_TYPE', function (newValue, oldValue) {
                if (newValue != oldValue) {
                    this.$store.dispatch('user/saveUserSetting', {name: 'B2B_CLIENT_MARGIN_TYPE', value: newValue});
                }
            });

            this.$watch('settings.B2B_CLIENT_MARGIN', async function (newValue, oldValue) {
                if (newValue != oldValue) {
                    await this.delay(800);
                    if(newValue == this.settings.B2B_CLIENT_MARGIN) {
                        this.$store.dispatch('user/saveUserSetting', {name: 'B2B_CLIENT_MARGIN', value: newValue});
                    }

                }
            });
            this.settings.B2B_CLIENT_PRICE_TYPE = 'net';
            this.settings.B2B_CLIENT_PRICE = 'client';
            this.settings.B2B_MARGIN_TYPE = 'percent';
        }

    }
</script>



// WEBPACK FOOTER //
// src/components/account/src/account/SettingPage.vue